import AuthService from '@/services/AuthService.js';
import { encryptStorage } from '@/utils/storage';

const auth = {
  namespaced: true,
  state: {
    userName: '',
    token: '',
    userConnected: false,
    isAdmin: true,
    isSupervisor: false,
    hasBot: false,
    visibleNumber: true,
    connected: true,
    isJoin: false,
    onlyNoReply: false,
    hasFexIaIntegrated: false,
  },
  mutations: {
    SET_AUTH_PARAMS(state, { token, userName }) {
      state.userName = userName;
      state.token = token;
    },
    CONNECT_USER(state, status) {
      state.userConnected = status;
    },
    UPDATE_SUPERVISOR(state, status) {
      state.isSupervisor = status;
    },
    UPDATE_ISADMIN(state, status) {
      state.isAdmin = status;
    },
    CHANGE_NO_REPLY_VIEW(state, status) {
      state.onlyNoReply = status;
    },
    SET_PARAM(state, { paramName, paramValue }) {
      state[paramName] = paramValue;
    },
  },
  actions: {
    async getUserInfo({ commit }, token) {
      return AuthService.getUserInfo(token)
        .then((response) => {
          commit('SET_PARAM', {
            paramName: 'hasBot',
            paramValue: response.data.results[0].has_bot,
          });
          commit('SET_PARAM', {
            paramName: 'activeBot',
            paramValue: response.data.results[0].bot_is_available,
          });
          commit('SET_PARAM', {
            paramName: 'visibleNumber',
            paramValue: response.data.results[0].visible_number,
          });
          commit('SET_PARAM', {
            paramName: 'hasFexIaIntegrated',
            paramValue: response.data.results[0].fexia_integrated,
          });
          commit('ui/labels/LOAD_LABELS', response.data.results[0].get_labels, {
            root: true,
          });
          return 'Success';
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async connectedUser({ state, commit, dispatch }, name) {
      const join = encryptStorage.getItem('user').join;
      var changeParam = false;
      if (state.connected === false) {
        changeParam = true;
      }
      return AuthService.connectedUser(join.tokenJoin, {
        nameDisconnection: name,
        status: !state.connected,
        userName: encryptStorage.getItem('user').Username,
      })
        .then((response) => {
          console.log('the user detail info', response);
          if (changeParam === true) {
            commit('SET_PARAM', {
              paramName: 'connected',
              paramValue: true,
            });
          }
          dispatch(
            'ui/alert/displayAlert',
            {
              message: 'Operación exitosa',
              description: state.connected ? `Conexión exitosa` : `Desconexión exitosa`,
              alertType: 'success',
            },
            { root: true },
          );
          return 'Success';
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async toggleActivateBot({ commit, dispatch }, { val, shortname, admin, username }) {
      const join = encryptStorage.getItem('user').join;
      return AuthService.activeBot(join.tokenJoin, {
        status: val,
        name: shortname,
        admin: admin,
        username: username,
      })
        .then(() => {
          commit('SET_PARAM', {
            paramName: 'activeBot',
            paramValue: val,
          });
          dispatch(
            'ui/alert/displayAlert',
            {
              message: 'Operación exitosa',
              description: val ? `Activación exitosa` : `Desactivación exitosa`,
              alertType: 'success',
            },
            { root: true },
          );
          return 'Success';
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async toggleNoReplyView({ commit }, val) {
      commit('CHANGE_NO_REPLY_VIEW', val);
    },
  },
};

export default auth;
